import _ from 'lodash'
import * as yup from 'yup'

yup.setLocale({
  mixed: {
    required: '項目が未入力です',
  },
  string: {
    email: 'メールアドレスに誤りがあります',
  },
})

yup.addMethod(yup.string, 'numberOnly', function(msg = '') {
  return this.test('numberOnly', msg ? msg : '半角数字を入力してください', function(value) {
    if (_.isEmpty(value)) return true

    return value.match(/^[0-9]*$/)
  })
})

yup.addMethod(yup.string, 'charLimit', function(from = 0, to = 1, msg = '') {
  return this.test('charLimit', msg ? msg : `${from}桁以上${to}桁以下で入力してください`, function(value) {
    if (_.isEmpty(value)) return true

    const len = value.length

    return len >= from && len <= to
  })
})

yup.addMethod(yup.string, 'maxChar', function(max = 1, msg = '') {
  return this.test('charLimit', msg ? msg : `${max}桁以内で入力してください`, function(value) {
    if (_.isEmpty(value)) return true

    return value.length <= max
  })
})

yup.addMethod(yup.string, 'noSpecialChar', function(msg = '') {
  return this.test('noSpecialChar', msg ? msg : '半角英数字、半角のみを入力してください', function(value) {
    if (_.isEmpty(value)) return true

    return value.match(/^\w+$/)
  })
})

yup.addMethod(yup.string, 'acceptSpecialChar', function(regex = /^[\w\\.\-,/\s]+$/, msg = '') {
  return this.test(
    'acceptSpecialChar',
    msg
      ? msg
      : '半角英数字、半角スペース、カンマ（,）、ピリオド（.）、スラッシュ（/）、ハイフン（-）のみを入力してください',
    function(value) {
      if (_.isEmpty(value)) return true

      return value.match(regex)
    }
  )
})
